import { Injectable } from "@angular/core";  
import { Resolve } from "@angular/router";  
import { AppLoadService } from "../services/app-load.service";


@Injectable()  
export class PrioryResolve implements Resolve<any>{
  constructor(private postService: AppLoadService) {}  
  resolve(): Promise<any> {
    return this.postService.getDataPriory();
  }
}